import { Component, inject } from '@angular/core';
import { SupervisorAuthService } from '../../../../../../../core/src/lib/services/supervisor-auth.service';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
  EAuthorizationOverviewFaqRoute,
  EAuthorizationOverviewSupportRoute,
  SupervisorHomeRoute,
  SupervisorMenuRoute,
} from '../../../../../../../core/src/lib/constants/routes.constant';
import { HomeApiClientService } from '../../../../../../../core/src/lib/api/v1/api/homeApi.client.service';
import { DocumentActionService } from '../../../../../../../core/src/lib/services/document-action.service';

@Component({
  selector: 'app-supervisor-header',
  imports: [RouterLink, AsyncPipe, NzIconModule, NzDropDownModule],
  templateUrl: './supervisor-header.component.html',
  styleUrl: './supervisor-header.component.scss',
})
export class SupervisorHeaderComponent {
  public supervisorAuthService: SupervisorAuthService = inject(SupervisorAuthService);
  private homeApiClientService: HomeApiClientService = inject(HomeApiClientService);
  private documentActionService: DocumentActionService = inject(DocumentActionService);

  homeRoute = SupervisorHomeRoute;
  supervisorMenuPageRoute = SupervisorMenuRoute;
  faqRoute = EAuthorizationOverviewFaqRoute;
  supportRoute = EAuthorizationOverviewSupportRoute;
  userName: string;


  public openUserInstructions() {
    this.homeApiClientService.homeApiReadUserInstructions().subscribe((res: Blob) => {
      this.documentActionService.openDocument(res);
    });
  }
}
